import { motion, AnimatePresence } from "framer-motion";
import { BellRing, Phone, Users, Clock } from "lucide-react";
import { EASE } from "@/components/Reveal";

const SEED = [
  { code: "CF-7K2QA", name: "Giulia Marchetti", when: "Sab 20:30", guests: 4, phone: "348 •••• 112", ago: "12 min fa" },
  { code: "CF-M9P3Z", name: "Thomas Weber", when: "Ven 19:30", guests: 2, phone: "+49 •••• 77", ago: "1 ora fa" },
];

export const OwnerFeed = ({ bookings }) => {
  const items = [
    ...bookings.map((b) => ({
      code: b.code,
      name: b.name,
      when: `${b.dateLabel} ${b.time}`,
      guests: b.guests,
      phone: b.phone,
      ago: "adesso",
      fresh: true,
    })),
    ...SEED,
  ];
  return (
    <div data-testid="owner-feed" className="rounded-3xl border border-line bg-ink p-6">
      <div className="flex items-center justify-between">
        <div>
          <p className="font-accent text-[10px] uppercase tracking-[0.3em] text-faded">Lato ristoratore</p>
          <h4 className="mt-1.5 font-serif text-xl tracking-tight text-bone">Prenotazioni in arrivo</h4>
        </div>
        <span className="relative flex h-9 w-9 items-center justify-center rounded-full border border-line text-terracotta">
          <BellRing size={16} />
          <span className="absolute -right-0.5 -top-0.5 flex h-4 min-w-4 items-center justify-center rounded-full bg-terracotta px-1 text-[9px] font-bold text-[#1c0d08]">
            {items.length}
          </span>
        </span>
      </div>
      <ul className="mt-5 space-y-2.5">
        <AnimatePresence initial={false}>
          {items.map((b) => (
            <motion.li
              key={b.code}
              layout
              initial={{ opacity: 0, y: -16, scale: 0.97 }}
              animate={{ opacity: 1, y: 0, scale: 1 }}
              transition={{ duration: 0.5, ease: EASE }}
              data-testid={`owner-feed-item-${b.code}`}
              className={`rounded-2xl border p-4 ${b.fresh ? "border-terracotta/60 bg-terracotta/5" : "border-line bg-panel"}`}
            >
              <div className="flex items-start justify-between gap-3">
                <div>
                  <p className="text-sm font-medium text-bone">{b.name}</p>
                  <p className="mt-1 flex flex-wrap items-center gap-x-3 gap-y-1 text-[11px] text-stone">
                    <span className="inline-flex items-center gap-1"><Clock size={11} /> {b.when}</span>
                    <span className="inline-flex items-center gap-1"><Users size={11} /> {b.guests}</span>
                    <span className="inline-flex items-center gap-1 normal-case"><Phone size={11} /> {b.phone}</span>
                  </p>
                </div>
                <div className="text-right">
                  <p className="font-mono text-[11px] tracking-wider text-ochre">{b.code}</p>
                  <p className="mt-1 text-[10px] text-faded">{b.ago}</p>
                </div>
              </div>
            </motion.li>
          ))}
        </AnimatePresence>
      </ul>
      <p className="mt-4 text-[11px] leading-relaxed text-faded">
        Nel prodotto reale: notifica push e email al locale, conferma SMS al cliente, sincronizzazione con Google Calendar e
        gestione no-show.
      </p>
    </div>
  );
};
